import { render, staticRenderFns } from "./AppMain.vue?vue&type=template&id=4fd9688e&scoped=true"
import script from "./AppMain.vue?vue&type=script&lang=ts"
export * from "./AppMain.vue?vue&type=script&lang=ts"
import style0 from "./AppMain.vue?vue&type=style&index=0&id=4fd9688e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fd9688e",
  null
  
)

export default component.exports